import {
  AutoExpandingTextareaConfig,
  TEXTAREA_CONFIG,
} from "./AutoExpandingTextarea.config";

export interface HeightCalculation {
  maxHeight: number;
  minHeight: number;
}

/**
 * Calculate minimum and maximum heights based on configuration
 * @param maxLines - Maximum number of lines before scrolling
 * @param config - Configuration object (defaults to TEXTAREA_CONFIG)
 * @returns Object with minHeight and maxHeight in pixels
 */
export const calculateHeights = (
  maxLines: number,
  config: AutoExpandingTextareaConfig = TEXTAREA_CONFIG,
): HeightCalculation => {
  const { lineHeight, padding } = config;

  return {
    maxHeight: lineHeight * maxLines + padding,
    minHeight: lineHeight + padding,
  };
};
